import { reducer } from "./reducer"

export const bundleReducer = reducer


// WEBPACK FOOTER //
// ./src/state/product/bundle/reducers/index.ts